var initialState = {
    openExample: false,
    setting: {
        condition: null
    }
}

export function winner_config(state = initialState, action) {
    switch (action.type) {
        case 'GET_WINNER_CONFIG_SETTING_SUCCESS':
            return {
                ...state,
                setting: action.data
            }
        case 'OPEN_EXAMPLE_WINNER_CONFIG':
            return {
                ...state,
                openExample: true
            }
        case 'CLOSE_EXAMPLE_WINNER_CONFIG':
            return {
                ...state,
                openExample: false
            }
        default:
            return state;
    }
}